import React, { useEffect } from "react";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { Commas, getDateFormate } from "../../../Common/AllDateTimeReleventFormate";
import PostNotFound from "../../../CustomComponents/AllLoader/PostNotFound";
import useChatNavigation from "../../../Common/useChatNavigation";
import { getBxpTogether2 } from "../../../../redux/ots/action";
import RentalDetailsLabel from "../../../Common/Label/RentalDetailsLabel";
import ProfilePic from "../../../../assests/imgs/Profileplaceholder.svg";

export default function RequestHistory({ count }) {
  const { letChat } = useChatNavigation();

  const dispatch = useDispatch()
  const togeter2 = useSelector(({ ots: { bxptogetherlist2 } }) => bxptogetherlist2);

  useEffect(() => {
    dispatch(getBxpTogether2(2));
  }, []);
  let lastDisplayedDate = null;
  return (
    <>
      <div className="posted-project umbrellaproject-sec pending-req">
        <>
          <h4>One Time Services (OTS)   ({count?.bxp_history || 0})</h4>
          {
            Array.isArray(togeter2?.bxp) && togeter2?.bxp.length > 0 ?
              <>
                {togeter2?.bxp.map((item, index) => {
                   const currentDate = item.created_on.split(" ")[0];
                   const shouldDisplayDate = currentDate !== lastDisplayedDate;
                   lastDisplayedDate = currentDate;
                return(
                  <div className="pending-row" key={index}>
                    {shouldDisplayDate &&<h6 className="date-name">{getDateFormate(item.created_on)}</h6>}
                    <div className="pending-img cursor-pending">
                      <div className="row align-items-center">
                        <div className="col-md-5">
                          <div className="pending-left">
                            <img src={item?.cover ? item?.cover : Array.isArray(item?.files) && item?.files[0]?.file} alt="" />
                            <div>
                              <h5>{item?.title}</h5>
                              <h3>$ {Commas(item?.total_price ? item?.total_price : item?.price)}</h3>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="pending-center">
                            <img src={item?.profile_image ? item?.profile_image:ProfilePic} alt="" />
                            <div>
                              <p>{item?.is_mine == 0 ? 'Seller' : 'Ordered by'}
                                <p> <img src={`${CloudStorage.cloudurl}/Assets/Images/common/star-1.svg`} alt="" /> {item?.rating || 0} ({item?.reviews || 0} reviews)</p>
                              </p>
                              <h5>{item?.first_name} {item?.last_name}</h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="pending-right">
                            <button onClick={() => letChat(item)} className="buttons border-button">
                              <img src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`} alt="" />
                            </button>
                            <button className="buttons border-button" >Declined</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )})
                }
              </>
              :
              <PostNotFound title={"No Post Found"} height={200} />
          }
        </>
        <>
          <h4>Purchase requests history ({count?.sale_history || 0})</h4>
          {
            Array.isArray(togeter2?.sale) && togeter2?.sale?.length > 0 ?
              <>
                {togeter2?.sale.map((item, index) => {
                   const currentDate = item.created_on.split(" ")[0];
                   const shouldDisplayDate = currentDate !== lastDisplayedDate;
                   lastDisplayedDate = currentDate;
                return(
                  <div className="pending-row" key={index}>
                    {shouldDisplayDate && <h6 className="date-name">{getDateFormate(item.created_on)}</h6>}
                    <div className="pending-img cursor-pending">
                      <div className="row align-items-center">
                        <div className="col-md-5">
                          <div className="pending-left">
                            <img src={item?.cover ? item?.cover : Array.isArray(item?.files) && item?.files[0]?.file} alt="" />
                            <div>
                              <h5>{item?.title}</h5>
                              <h3>$ {Commas(item?.total_price ? item?.total_price : item?.price)}</h3>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="pending-center">
                            <img src={item?.profile_image ? item?.profile_image:ProfilePic} alt="" />
                            <div>
                              <p>{item?.is_mine == 0 ? 'Seller' : 'Ordered by'}
                                <p> <img src={`${CloudStorage.cloudurl}/Assets/Images/common/star-1.svg`} alt="" /> {item?.rating || 0} ({item?.reviews || 0} reviews)</p>
                              </p>
                              <h5>{item?.first_name} {item?.last_name}</h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="pending-right">
                            <button onClick={() => letChat(item)} className="buttons border-button">
                              <img src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`} alt="" />
                            </button>
                            <button className="buttons border-button" >Declined</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )})
                }
              </>
              :
              <PostNotFound title={"No Post Found"} height={200} />
          }

        </>
        <>
          <h4>Rental requests history ({count?.rental_history || 0})</h4>
          {
            Array.isArray(togeter2?.rental) && togeter2?.rental?.length > 0 ?
              <>
                {togeter2?.rental.map((item, index) => {
                  const currentDate = item.created_on.split(" ")[0];
                  const shouldDisplayDate = currentDate !== lastDisplayedDate;
                  lastDisplayedDate = currentDate;
                return(
                  <div className="pending-row" key={index}>
                    {shouldDisplayDate &&<h6 className="date-name">{getDateFormate(item.created_on)}</h6>}
                    <div className="pending-img cursor-pending">
                      <div className="row align-items-center">
                        <div className="col-md-5">
                          <div className="pending-left">
                            <img src={item?.cover} alt="" />
                            <div>
                              <h5>{item?.title}</h5>
                              <h3>$ {Commas(item?.total_price ? item?.total_price : item?.price)}</h3>
                              <RentalDetailsLabel item={item} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="pending-center">
                            <img src={item?.profile_image ? item?.profile_image:ProfilePic} alt="" />
                            <div>
                              <p>{item?.is_mine == 0 ? 'Seller' : 'Ordered by'}
                                <p> <img src={`${CloudStorage.cloudurl}/Assets/Images/common/star-1.svg`} alt="" /> {item?.rating || 0} ({item?.reviews || 0} reviews)</p>
                              </p>
                              <h5>{item?.first_name} {item?.last_name}</h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="pending-right">
                            <button onClick={() => letChat(item)} className="buttons border-button">
                              <img src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`} alt="" />
                            </button>
                            <button className="buttons border-button" >Declined</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )})
                }
              </>
              :
              <PostNotFound title={"No Post Found"} height={200} />
          }

        </>
      </div>
    </>


  );
}
